import moment from "moment";

const dateUtils = {
  dayDiff: function(d1, d2) {
    return new Number((d2.getTime() - d1.getTime()) / 31536000000).toFixed(0);
  },
  calculateAge(birthDate) {
    if (birthDate != null) {
      const currentYear = new Date().getYear();
      const currentMonth = new Date().getMonth();

      const dobYear = new Date(birthDate).getYear();
      const dobMonth = new Date(birthDate).getMonth();

      //get years
      let yearAge = currentYear - dobYear;

      let monthAge = 0;
      //get months
      if (currentMonth >= dobMonth)
        //get months when current month is greater
        monthAge = currentMonth - dobMonth;
      else {
        yearAge--;
        monthAge = 12 + currentMonth - dobMonth;
      }

      const result = yearAge + monthAge * 0.01;

      return result;
    } else {
      return 0;
    }
  },
  yesterday() {
    return moment()
      .subtract(1, 'day')
      .startOf('day')
      .toDate();
  },
  today() {
    return moment()
      .subtract(1, 'day')
      .toDate();
  },
  subtract(date, amount, unit) {
    return moment(date)
      .subtract(amount, unit)
      .toDate();
  },
  toTimeSpan(time, period) {
    if (!time || !/^\d{2}:\d{2}$/.test(time)) return null;
    const [hourText, minuteText] = time.split(':');
    let hours = Number(hourText);
    const minutes = Number(minuteText);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
      2,
      '0'
    )}:00`;
  },
  fromTimeSpan(span) {
    if (!span) return { time: null, period: 'AM' };
    const [hourText, minuteText] = span.split(':');
    let hours = Number(hourText);
    const minutes = Number(minuteText);
    const period = hours >= 12 ? 'PM' : 'AM';
    if (hours > 12) hours -= 12;
    if (hours === 0) hours = 12;
    return {
      time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0'
      )}`,
      period,
    };
  },
};

export default dateUtils;
